import React from 'react';

const Modal = ({
    title = "Modal Title",
    isOpen,
    onClose,
    onSubmit,
    children,
    submitText = "Submit",
    className = "",
    withHeader = true,
    withButtons = true,
    width = "max-w-xs md:max-w-md lg:max-w-xl", // Responsive width defaults
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm transition-opacity">
            <div className={`${className} ${width} relative w-full max-h-[90vh] mx-4 bg-white rounded-lg shadow-xl dark:bg-gray-700 overflow-y-auto`}>
                {/* Modal header */}
                {withHeader && (
                    <div className="sticky top-0 bg-white dark:bg-gray-700 z-10 flex items-center justify-between p-4 border-b dark:border-gray-600">
                        <h3 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-white break-words">
                            {title}
                        </h3>
                        <button
                            type="button"
                            onClick={onClose}
                            className="p-2 -mr-2 text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors dark:hover:bg-gray-600 dark:hover:text-white"
                            aria-label="Close"
                        >
                            <svg
                                className="w-6 h-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                )}

                {/* Modal body */}
                <div className="p-4 md:p-6 space-y-4">
                    {children}
                </div>

                {/* Modal footer */}
                {withButtons && (
                    <div className="sticky bottom-0 bg-white dark:bg-gray-700 border-t dark:border-gray-600 p-4 md:p-6">
                        <div className="flex flex-col-reverse md:flex-row gap-3 md:gap-4 justify-end">
                            <button
                                type="button"
                                onClick={onClose}
                                className="w-full md:w-auto px-6 py-3 text-base font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors dark:bg-gray-600 dark:text-white dark:hover:bg-gray-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={onSubmit}
                                className="w-full md:w-auto px-6 py-3 text-base font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors focus:ring-4 focus:ring-blue-300"
                            >
                                {submitText}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;